import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    CircularProgress,
} from '@material-ui/core'
import swal from 'sweetalert'
import AjaxHandler from '../../../commons/ajax/AjaxHandler.js'
import Security from '../../../commons/security/Security.js'
import { StyledTableCell } from '../../../commons/utils/TableStyles.js'
import PeriodoPresupuestarioReglasAbm from './PeriodoPresupuestarioReglasAbm.jsx'
import backendStrings from '../../../lang/backendStrings.js'

class PeriodoPresupuestarioReglas extends Component {
    constructor(props) {
        super(props)
        this.ajaxHandler = new AjaxHandler()
        this.state = {
            redirectTo:       null,
            loading:          false,
            reglas:           [],
            periodosConfigId: null,
            modalOpen:        false,
            reglaEditando:    null,
            savingError:      null,
        }
        this.handleNuevaRegla  = this.handleNuevaRegla.bind(this)
        this.handleEditar      = this.handleEditar.bind(this)
        this.handleEliminar    = this.handleEliminar.bind(this)
        this.handleModalSave   = this.handleModalSave.bind(this)
        this.handleModalCancel = this.handleModalCancel.bind(this)
    }

    componentWillMount() {
        if (!Security.hasPermission('PERIODO_PRESUPUESTARIO_REGLAS_VER')) {
            this.setState({ redirectTo: '/error' })
            return
        }
        this.ajaxHandler.subscribe(this)
        this.loadConfig()
    }

    componentWillUnmount() {
        this.ajaxHandler.unsubscribe()
    }

    loadConfig() {
        this.setState({ loading: true })
        this.ajaxHandler.getJson('/periodo-configs')
            .then(function(data) {
                var configs = data && data.periodosConfig ? data.periodosConfig : []
                if (configs.length === 0) {
                    this.setState({ loading: false })
                    return
                }
                var configId = configs[0].id
                this.setState({ periodosConfigId: configId })
                return this.ajaxHandler.getJson('/periodo-reglas?periodos_config_id=' + configId)
            }.bind(this))
            .then(function(reglas) {
                if (!reglas) return
                this.setState({ reglas: Array.isArray(reglas) ? reglas : [] })
            }.bind(this))
            .catch(function(err) { this.ajaxHandler.handleError(err) }.bind(this))
            .finally(function() { this.setState({ loading: false }) }.bind(this))
    }

    handleNuevaRegla() {
        this.setState({ modalOpen: true, reglaEditando: null, savingError: null })
    }

    handleEditar(regla) {
        this.setState({ modalOpen: true, reglaEditando: regla, savingError: null })
    }

    handleEliminar(regla) {
        var intl      = this.props.intl
        var component = this
        swal({
            title: intl.formatMessage({ id: 'periodoPresupuestarioReglas.eliminar.titulo', defaultMessage: '¿Eliminar regla?' }),
            text:  intl.formatMessage({ id: 'periodoPresupuestarioReglas.eliminar.texto',  defaultMessage: 'Esta acción no se puede deshacer.' }),
            icon:  'warning',
            buttons: {
                cancel:  intl.formatMessage({ id: 'periodoPresupuestarioReglas.eliminar.cancelar', defaultMessage: 'Cancelar' }),
                confirm: { text: intl.formatMessage({ id: 'periodoPresupuestarioReglas.eliminar.confirmar', defaultMessage: 'Eliminar' }), value: true, className: 'btn-danger' },
            },
        }).then(function(confirmar) {
            if (!confirmar) return
            component.ajaxHandler.fetch('/periodo-reglas/' + regla.id, { method: 'DELETE' })
                .then(function(response) {
                    if (response.status === 200) {
                        component.loadConfig()
                        swal(
                            intl.formatMessage({ id: 'periodoPresupuestarioReglas.eliminar.exito_titulo', defaultMessage: 'Eliminada' }),
                            intl.formatMessage({ id: 'periodoPresupuestarioReglas.eliminar.exito_texto', defaultMessage: 'La regla fue eliminada correctamente.' }),
                            'success'
                        )
                    } else {
                        return response.json().then(function(data) {
                            var key = data.detalle && data.detalle[0]
                            var mensaje = intl.formatMessage(backendStrings[key] || backendStrings['errors.default'])
                            swal(intl.formatMessage({ id: 'periodoPresupuestarioReglas.error.titulo', defaultMessage: 'Error' }), mensaje, 'error')
                        })
                    }
                })
                .catch(function(err) { component.ajaxHandler.handleError(err) })
        })
    }

    handleModalSave(formData) {
        var component        = this
        var isEdit           = Boolean(this.state.reglaEditando)
        var periodosConfigId = this.state.periodosConfigId
        var intl             = this.props.intl

        var payload = Object.assign({}, formData, { periodos_config_id: periodosConfigId })

        var promise = isEdit
            ? component.ajaxHandler.fetch('/periodo-reglas/' + component.state.reglaEditando.id, {
                method:  'PUT',
                headers: { 'Content-Type': 'application/json' },
                body:    JSON.stringify(payload),
            })
            : component.ajaxHandler.fetch('/periodo-reglas', {
                method:  'POST',
                headers: { 'Content-Type': 'application/json' },
                body:    JSON.stringify(payload),
            })

        return promise
            .then(function(response) {
                if (response.status === 200) {
                    component.setState({ modalOpen: false, reglaEditando: null })
                    component.loadConfig()
                    swal(
                        intl.formatMessage({ id: 'periodoPresupuestarioReglas.guardar.exito_titulo', defaultMessage: 'Guardada' }),
                        intl.formatMessage({ id: 'periodoPresupuestarioReglas.guardar.exito_texto', defaultMessage: 'La regla fue guardada correctamente.' }),
                        'success'
                    )
                } else {
                    return response.json().then(function(data) {
                        var key = data.detalle && data.detalle[0]
                        component.setState({ savingError: intl.formatMessage(backendStrings[key] || backendStrings['errors.default']) })
                    })
                }
            })
            .catch(function(err) { component.ajaxHandler.handleError(err) })
    }

    handleModalCancel() {
        this.setState({ modalOpen: false, reglaEditando: null, savingError: null })
    }

    renderAcciones(regla) {
        var items = []
        if (regla.accion_notificacion) {
            items.push(
                <span key="notif" className="d-inline-flex align-items-center mr-2" title={this.props.intl.formatMessage({ id: 'periodoPresupuestarioReglas.accion.notificacion', defaultMessage: 'Notificación' })}>
                    <i className="fa fa-bell text-warning mr-1" style={{ fontSize: 15 }}></i>
                    <span style={{ fontSize: 14 }}><FormattedMessage id="periodoPresupuestarioReglas.accion.notificacion" defaultMessage="Notificación" /></span>
                </span>
            )
        }
        if (regla.accion_bloqueo) {
            items.push(
                <span key="bloqueo" className="d-inline-flex align-items-center" title={this.props.intl.formatMessage({ id: 'periodoPresupuestarioReglas.accion.bloqueo', defaultMessage: 'Bloqueo' })}>
                    <i className="fa fa-ban text-danger mr-1" style={{ fontSize: 15 }}></i>
                    <span style={{ fontSize: 14 }}><FormattedMessage id="periodoPresupuestarioReglas.accion.bloqueo" defaultMessage="Bloqueo" /></span>
                </span>
            )
        }
        return items
    }

    renderPorcentajeBadge(pct) {
        return (
            <span style={{ backgroundColor: '#e9ecef', color: '#495057', borderRadius: 4, padding: '3px 10px', fontWeight: 400, fontSize: 14 }}>
                {pct}%
            </span>
        )
    }

    render() {
        var state            = this.state
        var puedeCrearEditar = Security.hasPermission('PERIODO_PRESUPUESTARIO_REGLAS_CREAR_EDITAR')
        var puedeEliminar    = Security.hasPermission('PERIODO_PRESUPUESTARIO_REGLAS_ELIMINAR')
        var sinConfig        = !state.loading && state.periodosConfigId === null
        var colSpan          = (puedeCrearEditar || puedeEliminar) ? 5 : 4

        if (state.redirectTo) return <Redirect to={state.redirectTo} />

        return (
            <div className="mt-2">
                {state.modalOpen && (
                    <PeriodoPresupuestarioReglasAbm
                        regla={state.reglaEditando}
                        onSave={this.handleModalSave}
                        onCancel={this.handleModalCancel}
                        error={state.savingError}
                    />
                )}

                <div className="card">

                    {sinConfig && (
                        <div className="alert alert-warning mx-3 mt-2" role="alert">
                            <FormattedMessage
                                id="periodoPresupuestarioReglas.aviso.sin_config"
                                defaultMessage="No hay una configuración de período creada. Creá una configuración antes de gestionar reglas."
                            />
                        </div>
                    )}

                    <div className="card-content collpase show">
                        <div className="card-body card-dashboard">
                            <div className="container-fluid">
                                <div className="row dt-icons">
                                    <div className="col-6">
                                        {puedeCrearEditar && !sinConfig && (
                                            <button
                                                className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
                                                style={{ height: 55 }}
                                                title={this.props.intl.formatMessage({ id: 'periodoPresupuestarioReglas.boton.nueva', defaultMessage: 'Nueva Regla' })}
                                                onClick={this.handleNuevaRegla}
                                            >
                                                <i className="ft-plus"></i>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>
                                                <FormattedMessage id="periodoPresupuestarioReglas.columna.nombre" defaultMessage="Nombre de Regla" />
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <FormattedMessage id="periodoPresupuestarioReglas.columna.porcentaje" defaultMessage="% Umbral" />
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <FormattedMessage id="periodoPresupuestarioReglas.columna.acciones_configuradas" defaultMessage="Acción Configurada" />
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <FormattedMessage id="periodoPresupuestarioReglas.columna.estado" defaultMessage="Estado" />
                                            </StyledTableCell>
                                            {(puedeCrearEditar || puedeEliminar) && (
                                                <StyledTableCell align="center">
                                                    <FormattedMessage id="periodoPresupuestarioReglas.columna.acciones" defaultMessage="Acciones" />
                                                </StyledTableCell>
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {state.loading && (
                                            <TableRow>
                                                <StyledTableCell colSpan={colSpan} align="center" style={{ padding: 32 }}>
                                                    <CircularProgress />
                                                </StyledTableCell>
                                            </TableRow>
                                        )}
                                        {!state.loading && state.reglas.length === 0 && (
                                            <TableRow>
                                                <StyledTableCell colSpan={colSpan} align="center" style={{ padding: 32, color: '#999' }}>
                                                    <FormattedMessage id="periodoPresupuestarioReglas.sin_reglas" defaultMessage="No hay reglas configuradas. Creá la primera regla usando el botón +" />
                                                </StyledTableCell>
                                            </TableRow>
                                        )}
                                        {!state.loading && state.reglas.map(function(regla) {
                                            return (
                                                <TableRow key={regla.id} hover>
                                                    <StyledTableCell>{regla.nombre}</StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {this.renderPorcentajeBadge(regla.porcentaje_umbral)}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <div className="d-flex align-items-center" style={{ gap: 12 }}>
                                                            {this.renderAcciones(regla)}
                                                        </div>
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <div style={{
                                                            backgroundColor: regla.activa ? '#28d094' : '#6c757d',
                                                            padding: '4px 8px',
                                                            borderRadius: '7px',
                                                            color: 'white',
                                                            fontSize: '12px',
                                                            border: '1px solid',
                                                            width: 'fit-content',
                                                            margin: '0 auto',
                                                        }}>
                                                            {regla.activa
                                                                ? <FormattedMessage id="periodoPresupuestarioReglas.estado.activa" defaultMessage="Activa" />
                                                                : <FormattedMessage id="periodoPresupuestarioReglas.estado.inactiva" defaultMessage="Inactiva" />
                                                            }
                                                        </div>
                                                    </StyledTableCell>
                                                    {(puedeCrearEditar || puedeEliminar) && (
                                                        <StyledTableCell align="center">
                                                            <div className="d-inline-flex" style={{ gap: 0 }}>
                                                                {puedeCrearEditar && (
                                                                    <button
                                                                        className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
                                                                        title={this.props.intl.formatMessage({ id: 'periodoPresupuestarioReglas.accion.editar', defaultMessage: 'Editar' })}
                                                                        onClick={function() { this.handleEditar(regla) }.bind(this)}
                                                                    >
                                                                        <i className="fa fa-pencil fa-xs"></i>
                                                                    </button>
                                                                )}
                                                                {puedeEliminar && (
                                                                    <button
                                                                        className="action delete btn btn-sm btn-icon btn-dt-grid text-danger"
                                                                        title={this.props.intl.formatMessage({ id: 'periodoPresupuestarioReglas.accion.eliminar', defaultMessage: 'Eliminar' })}
                                                                        onClick={function() { this.handleEliminar(regla) }.bind(this)}
                                                                    >
                                                                        <i className="fa fa-trash fa-xs"></i>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </StyledTableCell>
                                                    )}
                                                </TableRow>
                                            )
                                        }.bind(this))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default injectIntl(PeriodoPresupuestarioReglas)
